export default __webpack_public_path__ + "static/media/Home-Essentials.c18e87ff.jpg";